import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { getEventImageUrl, placeholderImage } from 'shared/util/image'

function EventThumb({ event, className = '', alt, decorative = false }) {
  const resolved = getEventImageUrl(event)
  const [src, setSrc] = useState(resolved)

  useEffect(() => {
    setSrc(resolved)
  }, [resolved])

  return (
    <img
      src={src}
      alt={decorative ? '' : alt ?? event?.sTitle ?? ''}
      className={className}
      aria-hidden={decorative || undefined}
      onError={() => {
        if (src !== placeholderImage) setSrc(placeholderImage)
      }}
    />
  )
}

EventThumb.propTypes = {
  event: PropTypes.object,
  className: PropTypes.string,
  alt: PropTypes.string,
  decorative: PropTypes.bool
}

export default EventThumb
